const formatDate = (date: Date) => {
  return `${new Date(date).getDate()}/${new Date(date).getMonth() +
    1}/${new Date(date)
    .getFullYear()
    .toString()
    .slice(2)}`;
};

export default formatDate;
